// arch-slider-overlay-fix.js
(function () {
  function parseColorFromStyle(styleText) {
    if (!styleText) return null;
    // try rgba(...) or rgb(...)
    var m = styleText.match(/rgba?\([^\)]+\)/i);
    if (m) return m[0].trim();
    // try hex #rrggbb or #rgb
    m = styleText.match(/#([0-9a-f]{3}|[0-9a-f]{6})/i);
    if (m) return m[0].trim();
    return null;
  }

  function parseOpacityFromStyle(styleText) {
    if (!styleText) return null;
    var m = styleText.match(/opacity\s*:\s*([\d.]+)/i);
    if (m) return parseFloat(m[1]);
    // check for rgba(..., a)
    m = styleText.match(/rgba\([^\)]+,\s*([\d.]+)\)/i);
    if (m) return parseFloat(m[1]);
    return null;
  }

  function normalizeAlpha(a) {
    if (a === null || a === undefined || a === "") return null;
    a = parseFloat(a);
    if (isNaN(a)) return null;
    // if user supplied percent (like 50) convert to 0.5
    if (a > 1) a = a / 100;
    // clamp
    if (a < 0) a = 0;
    if (a > 1) a = 1;
    return a;
  }

  function applyOverlays() {
    var sections = document.querySelectorAll('.arch-slider, [data-section-id].arch-slider');
    if (!sections.length) sections = document.querySelectorAll('.arch-slider'); // fallback
    Array.prototype.forEach.call(sections, function (section) {
      var slides = section.querySelectorAll('.arch-slider__slide');
      Array.prototype.forEach.call(slides, function (slide) {
        try {
          var ov = slide.querySelector('.arch-slider__overlay');
          var color = null;
          var alpha = null;

          // 1) try data attributes on overlay (common in some edits)
          if (ov) {
            if (ov.dataset && ov.dataset.overlayColor) color = ov.dataset.overlayColor;
            if (ov.getAttribute && ov.getAttribute('data-overlay-color') && !color) color = ov.getAttribute('data-overlay-color');
            if (ov.dataset && ov.dataset.overlayOpacity) alpha = ov.dataset.overlayOpacity;
            if (ov.getAttribute && ov.getAttribute('data-overlay-opacity') && !alpha) alpha = ov.getAttribute('data-overlay-opacity');
          }

          // 2) try inline style on overlay element
          if ((!color || color === '') && ov) {
            var styleAttr = ov.getAttribute('style') || '';
            var parsed = parseColorFromStyle(styleAttr);
            if (parsed) color = parsed;
            var parsedOp = parseOpacityFromStyle(styleAttr);
            if (parsedOp !== null) alpha = parsedOp;
          }

          // 3) try inline style on slide itself (some variants set CSS vars inline)
          if ((!color || color === '') ) {
            var slideStyle = slide.getAttribute('style') || '';
            var parsedS = parseColorFromStyle(slideStyle);
            if (parsedS) color = parsedS;
            var parsedSO = parseOpacityFromStyle(slideStyle);
            if (parsedSO !== null) alpha = parsedSO;
            // also try CSS var values in style attribute (e.g., --slide-overlay: #000)
            var varMatch = slideStyle.match(/--slide-overlay\s*:\s*([^;]+);?/i);
            if (varMatch && varMatch[1]) color = varMatch[1].trim();
            var varAlphaMatch = slideStyle.match(/--slide-overlay-alpha\s*:\s*([^;]+);?/i);
            if (varAlphaMatch && varAlphaMatch[1]) alpha = varAlphaMatch[1].trim();
          }

          // 4) fallback: computed style from overlay
          if ((!color || color === '') && ov) {
            var computed = window.getComputedStyle(ov).backgroundColor;
            if (computed && computed !== 'rgba(0, 0, 0, 0)' && computed !== 'transparent') color = computed;
            // computed opacity can't be reliably taken because it could come from parent
          }

          // Normalize alpha
          alpha = normalizeAlpha(alpha);

          // If we only have a color but no alpha, default to full opacity (1)
          if (color && (alpha === null || alpha === undefined)) alpha = 1;

          // If nothing found, skip
          if (!color) return;

          // Apply CSS vars to slide
          slide.style.setProperty('--slide-overlay', color);
          slide.style.setProperty('--slide-overlay-alpha', String(alpha));

          // hide the old overlay element to avoid doubling up (keeps DOM intact)
          if (ov) {
            ov.style.display = 'none';
            ov.style.visibility = 'hidden';
          }
        } catch (e) {
          // swallow per-slide errors so one bad slide doesn't break rest
          console.error('arch-slider overlay fix error on slide', e);
        }
      });
    });
  }

  // Run once after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverlays);
  } else {
    applyOverlays();
  }

  // Also re-run when Shopify theme editor updates the section (listen for message)
  // This helps the theme editor live preview when settings change
  window.addEventListener('message', function (ev) {
    try {
      // some editor messages are strings; do a quick contains-check
      if (ev.data && (ev.data == 'shopify:section:load' || (typeof ev.data === 'string' && ev.data.indexOf('shopify') !== -1))) {
        setTimeout(applyOverlays, 50);
      } else if (ev.data && ev.data.type && ev.data.type.indexOf && ev.data.type.indexOf('shopify') !== -1) {
        setTimeout(applyOverlays, 50);
      }
    } catch (e) { /* ignore */ }
  }, false);
})();
